import popularConnectionsAPI, { PopularConnectionsRequest, PopularConnectionsResponse } from '@api/popularConnections'
import { makeLoader } from '@lib/loader'

export const usePopularConnections = makeLoader<PopularConnectionsRequest, PopularConnectionsResponse>({
  key: 'popularConnections',
  loader: async params => await popularConnectionsAPI.load(params),
})
